import(/* webpackMode: "eager" */ "/foodcarttracker/app/globals.css");
import(/* webpackMode: "eager" */ "/foodcarttracker/components/sentry-provider.tsx");
import(/* webpackMode: "eager" */ "/foodcarttracker/components/theme-provider.tsx");
import(/* webpackMode: "eager" */ "/foodcarttracker/components/ui/toaster.tsx");
import(/* webpackMode: "eager" */ "/foodcarttracker/components/ui/tooltip.tsx")